<template>
    <el-dialog custom-class="medium-dialog" :visible.sync="dialogVisible" :append-to-body="true">
      <el-image :src="item.url" alt="" v-for="item in fileList" :key="item.url" @click="openUrl(item.url)"></el-image>
      <div slot="footer" class="dialog-footer" style="text-align: center">
        <el-button @click="dialogVisible = false">关 闭</el-button>
      </div>
    </el-dialog>
</template>


<script>
  import {getListData} from '@/api/attachment'

  export default {
    name: "user",
    data() {
      return {
        dialogVisible:false,
        fileList: []
      }
    },
    props: {

    },
    //
    watch: {
    },
    methods: {
      bindData(groupGuid,groupType) {
        var data = {
          groupGuid: groupGuid,
          groupType: groupType
        };
        this.dialogVisible=true;
        this.fileList = []
        getListData(data).then((result) => {
          for (let i in result.data.obj) {
            this.fileList.push({
              "name": result.data.obj[i]["filename"],
              "url": result.data.obj[i]["virtualpath"],
              "size": result.data.obj[i]["filesize"]
            })
          }
        })
      },
      openUrl(url){
        window.open(url, "");
      },
    },
    computed: {},
    mounted() {
    },
  }
</script>


<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/common/Fileimgview.vue